import Navbar1 from './Navbar1';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import config from '../../config';
import { useEffect } from 'react';

var url = config.nav.url;

var step0 = url+'step0';

const Dashboard = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const type = localStorage.getItem('type');
    
    useEffect(()=>{
        if(type === 'exam'){
            navigate('/admin')
        }
    })

    return (
        <div>
            <Navbar1/>
            <div className="container m-5">
                <div className="row">
                <div className='col-md-3 m-4'>
                        <div className="row cadre">
                            <p className="mt-3 pt-0 text-white fw-bolder" id="dashb">{t('dashboard')}</p>
                            <div className="m-3 mt-0 mb-0">
                                <a href="/step0" className='deco_null'>
                                    <div className="row justify-conter-between">
                                        <p className="col-md-10">{t('new_application')}</p>
                                        <i className="col-md-1 fa fa-arrow-right me-2"></i>
                                    </div>
                                </a>
                                <a href="/step9" className='deco_null'>
                                    <div className="row justify-conter-between">
                                        <p className="col-md-10">{t('see_my_application')}</p>
                                        <i className="col-md-1 fa fa-arrow-right me-2"></i>
                                    </div>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 pl-4">
                        <p className="lead fs-1">{t('start_application')}</p>
                        <div className="row">
                            <p className="col-md-8">{t('start_application_text')}.</p>
                            <input type="button" className='col-md-5 btn btn-outline-primary'  id="vehicle1" name="vehicle1" value="Commencez" onClick={()=>{navigate(step0)}}/>
                        </div>
                    </div>
                </div>
                <div className="space"/>
                <div className="space"/>
            </div>
        </div>
    )
}

export default Dashboard;
